// LNK-2: a meeting link can open on a given tab (?tab=transcript from the Slack post).
export const DIGEST_TABS = ["summary", "full-brief", "transcript"] as const;
export type DigestTab = (typeof DIGEST_TABS)[number];

export const digestTabFrom = (param: string | null | undefined): DigestTab =>
  (DIGEST_TABS as readonly string[]).includes(param || "") ? (param as DigestTab) : "summary";
